import { render, staticRenderFns } from "./MenuSide.vue?vue&type=template&id=7f235af2"
import script from "./MenuSide.vue?vue&type=script&lang=js"
export * from "./MenuSide.vue?vue&type=script&lang=js"
import style0 from "./MenuSide.vue?vue&type=style&index=0&id=7f235af2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports